import './OpportunityDetails.scss';

import React from 'react';
import { connect } from "react-redux";
import { routerActions } from "react-router-redux";

import { clearOpportunity, getOpportunityById } from 'containers/Opportunities/store/actions';

import A from 'components/A';
import Avatar from 'components/Avatar';
import Button from 'components/Button';
import CircleIcon from 'components/CircleIcon';
import H1 from 'components/H1';
import H3 from 'components/H3';
import LoadingCircle from 'components/LoadingCircle';
import MessageModal from 'components/Modal/MessageModal';
import OpportunityMetadata from 'containers/Opportunities/components/OpportunityMetadata';
import PageContent from 'components/PageContent';
import Pill from 'components/Pill';

class OpportunityDetails extends React.Component {
    componentWillMount() {
        document.body.classList.add('opportunity-details-page');

        this.props.getOpportunityById(this.props.params.id)
            .then((res) => {
                if(res.data.data.deleted === true) {
                    this.props.changeLocation('/404')
                }
            })
            .catch((err) => {
                this.props.changeLocation('/404');
            })
    }

    componentWillUnmount() {
        document.body.classList.remove('opportunity-details-page');
        this.props.clearOpportunity();
    }

    render() {
        let { opportunity } = this.props.opportunities;
        let company = opportunity.company || {};

        if(this.props.opportunities.isFetching === true) {
            return (
                <PageContent className="opportunity-details">
                    <LoadingCircle />
                </PageContent>
            );
        } else {
            return (
                <PageContent className="opportunity-details">
                    <header className="opportunity-details__header">

                        <section className="opportunity-details__posted-by">
                            <A to={`/business/${company.id}`}>
                                <Avatar imageUrl={company.profilePicUrl} size="small"/> posted by {company.name}
                            </A>
                        </section>

                        <H1>
                            {opportunity.title}
                        </H1>

                        <OpportunityMetadata
                            allowsRemote={opportunity.allowsRemote}
                            duration={opportunity.duration}
                            endDate={opportunity.endDate}
                            location={company.location != null ? company.location.name : 'Remote'}
                            startDate={opportunity.startDate}
                        />

                        <div className="opportunity-details__actions">
                            {this.props.auth.user.company && this.props.auth.user.company.id === company.id ? null : (
                                <Button className="profile__action"
                                        noStyles
                                        onClick={() => this.messageModal.showMessageModal()}>
                                    <span className="profile__action-icon--wrapper">
                                        <CircleIcon type="email" />
                                    </span>
                                </Button>
                            )}
                            {/*<Button noStyles
                                onClick={() => alert('favorite opportunity')}>
                            <CircleIcon type="heart" />
                        </Button>*/}
                        </div>
                    </header>

                    <div className="opportunity-details__summary">
                        <H3>
                            Summary
                        </H3>
                        <p>{opportunity.summary}</p>
                    </div>

                    <div className="opportunity-details__description">
                        <h3>
                            Details about the role
                        </h3>

                        <div dangerouslySetInnerHTML={{__html: opportunity.description}}/>
                    </div>

                    {opportunity.experienceLevel != null ? (
                        <div className="opportunity-details__experience-level">
                            <h3>
                                Required Experience Level
                            </h3>
                            {opportunity.experienceLevel}
                        </div>
                    ) : null}

                    {opportunity.specializations != null && opportunity.specializations.length > 0 ? (
                        <div className="opportunity-details__specializations">
                            <h3>
                                Specialties
                            </h3>
                            <ul className="opportunity-details__specializations-list opportunity-details__pill-list">
                                {opportunity.specializations.map((s) => {
                                    return (
                                        <Pill
                                            className="opportunity-details__specialization opportunity-details__pill"
                                            content={s.name}
                                        />
                                    );
                                })}
                            </ul>
                        </div>
                    ) : null}

                    {opportunity.industryExperiences != null && opportunity.industryExperiences.length > 0 ? (
                        <div className="opportunity-details__industry-experiences">
                            <h3>
                                Industries
                            </h3>
                            <ul className="opportunity-details__industry-experiences-list opportunity-details__pill-list">
                                {opportunity.industryExperiences.map((ie) => {
                                    return (
                                        <Pill
                                            className="opportunity-details__industry-experience-type opportunity-details__pill"
                                            content={ie.name}
                                        />
                                    );
                                })}
                            </ul>
                        </div>
                    ) : null}

                    {this.props.auth.user.company == null ? (
                        <div className="opportunity-details__response-options">
                            <Button onClick={() => this.messageModal.showMessageModal()}>
                                I'm Interested
                            </Button>

                            <Button className="a-button--cancel"
                                    onClick={() => window.history.back()}>
                                Back to Results
                            </Button>
                        </div>
                    ) : null}

                    <MessageModal
                        onRef={ref => (this.messageModal = ref)}
                    />
                </PageContent>
            );
        }
    }
}

const mapStateToProps = (state) => {
    return {
        auth: state.auth,
        opportunities: state.opportunities
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        changeLocation: (path) => dispatch(routerActions.push(path)),
        clearOpportunity: () => dispatch(clearOpportunity()),
        getOpportunityById: (opportunityId) => dispatch(getOpportunityById(opportunityId))
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(OpportunityDetails);



// WEBPACK FOOTER //
// ./src/containers/Opportunities/OpportunityDetails/index.js